module.exports = __webpack_public_path__ + "img/ic_radio_checked_primary.ac03584e.svg";